import React, { useState } from 'react';
import styles from './UpdateSubscriptionPaymentModal.module.css';
import { PaymentIcon } from 'react-svg-credit-card-payment-icons';

const UpdateSubscriptionPaymentModal = ({ 
  isOpen, 
  onClose, 
  paymentMethods, 
  currentPaymentMethodId, 
  onUpdate 
}) => {
  const [selectedPaymentMethodId, setSelectedPaymentMethodId] = useState(currentPaymentMethodId);
  const [isUpdating, setIsUpdating] = useState(false);

  const handleUpdate = async () => {
    if (!selectedPaymentMethodId || selectedPaymentMethodId === currentPaymentMethodId) {
      return;
    }

    setIsUpdating(true);
    try {
      await onUpdate(selectedPaymentMethodId);
      onClose();
    } catch (error) {
      console.error('Error updating subscription payment method:', error);
    } finally {
      setIsUpdating(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <h3>Update Subscription Payment Method</h3>
          <button className={styles.closeButton} onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <div className={styles.content}>
          <p className={styles.description}>
            Select a payment method to use for your next subscription billing:
          </p>

          {paymentMethods.length === 0 ? (
            <div className={styles.emptyState}>
              <p>No payment methods available. Please add a payment method first.</p>
            </div>
          ) : (
            <div className={styles.paymentMethodsList}>
              {paymentMethods.map(method => (
                <div 
                  key={method.id} 
                  className={`${styles.paymentMethodCard} ${
                    selectedPaymentMethodId === method.id ? styles.selected : ''
                  } ${
                    currentPaymentMethodId === method.id ? styles.current : ''
                  }`}
                  onClick={() => setSelectedPaymentMethodId(method.id)}
                >
                  <div className={styles.radioWrapper}>
                    <input
                      type="radio"
                      id={`payment-method-${method.id}`}
                      name="paymentMethod"
                      value={method.id}
                      checked={selectedPaymentMethodId === method.id}
                      onChange={() => setSelectedPaymentMethodId(method.id)}
                    />
                  </div>
                  
                  <div className={styles.methodInfo}>
                    <div className={styles.cardDetails}>
                      <div className={styles.cardIconWrapper}>
                        <PaymentIcon 
                          type={method.card_brand.toLowerCase()} 
                          format="flat" 
                          width={32} 
                        />
                      </div>
                      <span className={styles.cardNumber}>
                        •••• •••• •••• {method.last_four}
                      </span>
                      <div className={styles.badges}>
                        {Boolean(method.is_default) && (
                          <span className={styles.defaultBadge}>Default</span>
                        )}
                        {currentPaymentMethodId === method.id && (
                          <span className={styles.currentBadge}>Current</span>
                        )}
                      </div>
                    </div>
                    <div className={styles.methodDetails}>
                      <p className={styles.cardHolder}>{method.card_holder_name}</p>
                      <p className={styles.expiry}>Expires {method.expiry_month}/{method.expiry_year}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={styles.footer}>
          <button 
            className={styles.cancelButton} 
            onClick={onClose}
            disabled={isUpdating}
          >
            Cancel
          </button>
          <button 
            className={styles.updateButton} 
            onClick={handleUpdate}
            disabled={
              isUpdating || 
              !selectedPaymentMethodId || 
              selectedPaymentMethodId === currentPaymentMethodId ||
              paymentMethods.length === 0
            }
          >
            {isUpdating ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Updating...
              </>
            ) : (
              'Update Payment Method'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateSubscriptionPaymentModal; 